<template>
    <div class="type-select-option">
        <svg-vue :icon="icon" class="option-icon" />

        <div class="description">
            {{ description }}
        </div>

        <button type="button" class="form-button is-purple" @click="onSelect(type)">
            {{ buttonLabel }}
        </button>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            required: true,
            type: String,
        },
        icon: {
            required: true,
            type: String,
        },
        description: {
            required: true,
            type: String,
        },
        buttonLabel: {
            required: true,
            type: String,
        },
        onSelect: {
            required: true,
            type: Function,
        },
    },
};
</script>
<style scoped lang="scss">
    @use './TypeSelectOption.scss';
</style>
